import template from './attendance-detail.html';
import controller from './attendance-detail.controller';

let attendanceDetailComponent = {
  bindings: {},
  template,
  controller
};

export default attendanceDetailComponent;



// WEBPACK FOOTER //
// ./client/app/components/attendance/attendance-detail.component.js